import { useNav } from '../app/nav.tsx';
import { Bell } from '../screens/Engage.tsx';
import { Icon } from './Icon.tsx';
import { CFG_TOP, SIDE_VIEWS, useWide } from '../app/desk.tsx';
import { useHiddenMoney } from './money.tsx';

// Cabeçalho com o logotipo, avisos, olho (esconder valores) e o "+" de novo agendamento.
export function HeaderWordmark({ withEye = false }: { withEye?: boolean }) {
  const nav = useNav();
  const [hid, toggle] = useHiddenMoney();
  return (
    <div className="hd">
      <div className="wordmark-mark" role="img" aria-label="Sublime Nail Design" />
      <div className="hd-actions">
        <Bell />
        {withEye && (
          <button className="iconbtn" aria-label={hid ? 'Mostrar valores' : 'Esconder valores'} aria-pressed={hid} onClick={toggle}>
            <Icon name={hid ? 'eyeOff' : 'eye'} />
          </button>
        )}
        <button className="iconbtn brand" aria-label="Novo agendamento" onClick={() => nav.open({ kind: 'novo' })}><Icon name="plusLg" /></button>
      </div>
    </div>
  );
}

export function BackHeader({ title, label = 'Mais', to }: { title: string; label?: string; to?: () => void }) {
  const nav = useNav();
  // no computador, as seções do menu lateral abrem direto: sem "voltar"
  const top = useWide() && (SIDE_VIEWS.has(nav.view) || CFG_TOP.has(nav.view));
  if (top) return <div className="back-hd bk2 desk-top"><h1>{title}</h1></div>;
  return (
    <div className="back-hd bk2">
      <button className="bk" onClick={to ?? nav.back}><Icon name="back" /><span>{label}</span></button>
      <h1>{title}</h1>
    </div>
  );
}
